import { httpClient } from '@/service'
import shared from '@/shared/shared'

export default {

  loadWholeOrderNextItemLotMovements(component) {
    if (!component.wholeOrderItemLotMovements) {
      component.wholeOrderItemLotMovements = [];
    }

    let size = 5;
    let page = Math.floor(component.wholeOrderItemLotMovements.length / size);

    component.loadingWholeOrderItemLotMovements = true;
    httpClient
    .post(`${process.env.VUE_APP_API_URL}item-lot-movements/condition?page=${page}&size=${size}&sort=createdAt,desc`, {
      conditions: [{
        field: 'orderItem.order.id',
        value: component.order.id
      }]
    })
    .then(({ data }) => {
      component.loadingWholeOrderItemLotMovements = false;
      component.wholeOrderIsItemLotMovementsLastPage = data.data.last;

      if (data.data.content) {
        data.data.content.forEach(ilm => {
          ilm.orderItem = null;
          ilm.formattedDate = shared.formatDate(ilm.createdAt);

          let index = component.wholeOrderItemLotMovements.findIndex(currentIlm => currentIlm.id === ilm.id);
          if (index > -1) {
            component.wholeOrderItemLotMovements[index] = ilm;
          } else {
            component.wholeOrderItemLotMovements.push(ilm);
          }
        });
      }
    })
    .catch((error) => {
      component.loadingWholeOrderItemLotMovements = false;
      if (error.message) {
        component.$notify.error(error)
      }
    });
  },

  getItemLotMovementsFromMovementResponse(data) {
    let newItemLotMovements = [];

    if (data.data.data.subEntities && data.data.data.subEntities.length) {
      data.data.data.subEntities.forEach(se => {
        se.formattedDate = shared.formatDate(se.createdAt);

        let newItemLotMovement = JSON.parse(JSON.stringify(se));
        newItemLotMovement.orderItem = null;
        newItemLotMovements.push(newItemLotMovement);
      });
    } else {
      data.data.data.formattedDate = shared.formatDate(data.data.data.createdAt);

      let newItemLotMovement = JSON.parse(JSON.stringify(data.data.data));
      newItemLotMovement.orderItem = null;
      newItemLotMovements.push(newItemLotMovement);
    }

    return newItemLotMovements;
  },

  sortOrderItems(order) {
    if (order && order.orderItems) {
      order.orderItems.sort((a, b) => {
        let aFinished = (a.alocatedQuantity || 0) >= (a.quantity || 0);
        let bFinished = (b.alocatedQuantity || 0) >= (b.quantity || 0);

        if (aFinished) {
          return 1;
        } else if (bFinished) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  }

}
